module.exports = __webpack_public_path__ + "images/application/templates/blank-d71f2e2c.png";